import React, { useEffect, useState } from "react";
import {
  FaBookOpen,
  FaChartLine,
  FaUsers,
  FaLightbulb,
  FaWhatsapp,
  FaUniversity,
  FaHandshake,
} from "react-icons/fa";
import { useLocation } from "react-router-dom";

import aboutImg from "../components/assets/images/About/About2.jpeg";
import mision from "../components/assets/images/About/Mision.svg";
import vision from "../components/assets/images/About/Vision.svg";
import imgs from "../components/assets/images/join1.png";
import Administrative from "./Administrative";

/* 🔥 AGREGA MÁS FOTOS DE CEVATUR */
import about2 from "../../src/components/assets/images/About/About3.png";
import about3 from "../components/assets/images/About/About1.jpeg";
import about4 from "../../src/components/assets/images/ceva-piura-log.png";

/* =========================
   COLORES
========================= */
const COLORS = {
  red: "#D71920",
  blue: "#004AAD",
  yellow: "#F4C400",
  dark: "#1F2937",
  text: "#4B5563",
};

export const About = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);

      if (element) {
        const headerOffset = 100;

        const top =
          element.getBoundingClientRect().top +
          window.scrollY -
          headerOffset;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    }
  }, [location]);

  return (
    <>
      {/* HERO */}
      <section
        id="about"
        className="relative py-20 overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg,#ffffff 0%,#f8f9fa 55%,#eef4ff 100%)",
        }}
      >
        {/* BARRA SUPERIOR */}
        <div className="absolute top-0 left-0 w-full h-2 flex z-20">
          <div className="w-1/3 bg-red-600"></div>
          <div className="w-1/3 bg-yellow-400"></div>
          <div className="w-1/3 bg-blue-700"></div>
        </div>

        <div className="container mx-auto px-4">
          <div className="text-center max-w-5xl mx-auto mb-16">
            <span
              className="uppercase tracking-[4px] text-sm font-semibold"
              style={{ color: COLORS.blue }}
            >
              Institución Líder
            </span>

            <h1
              className="text-5xl md:text-4xl font-bold mt-4 leading-tight"
              style={{ color: COLORS.red }}
            >
              Más de 50 años formando profesionales con visión de futuro
            </h1>

            <div
              className="w-28 h-1 rounded-full mx-auto my-6"
              style={{ backgroundColor: COLORS.yellow }}
            ></div>

            <p
              className="text-lg leading-relaxed"
              style={{ color: COLORS.text }}
            >
              Somos el primer Instituto Superior de Turismo del Perú.
              Formamos profesionales competitivos mediante educación moderna,
              práctica y alineada al mercado laboral.
            </p>
          </div>

          <div className="grid grid-cols-4 gap-6 md:grid-cols-2 sm:grid-cols-1">
            <FeatureCard
              icon={<FaBookOpen />}
              title="Trayectoria"
              text="Más de cinco décadas de experiencia."
            />

            <FeatureCard
              icon={<FaUsers />}
              title="Comunidad"
              text="Miles de egresados destacados."
            />

            <FeatureCard
              icon={<FaChartLine />}
              title="Empleabilidad"
              text="Formación orientada al mercado."
            />

            <FeatureCard
              icon={<FaLightbulb />}
              title="Innovación"
              text="Metodologías modernas y dinámicas."
            />
          </div>
        </div>
      </section>

      <AboutContent />
    </>
  );
};

/* =========================
   FEATURE CARD
========================= */
const FeatureCard = ({ icon, title, text }) => {
  return (
    <div className="bg-white rounded-2xl p-7 shadow-md border border-gray-100 hover:shadow-xl transition duration-300 hover:-translate-y-1">
      <div
        className="w-14 h-14 rounded-xl flex items-center justify-center text-2xl mb-5"
        style={{
          backgroundColor: "rgba(0,74,173,.08)",
          color: COLORS.blue,
        }}
      >
        {icon}
      </div>

      <h3 className="text-lg font-bold text-gray-800">{title}</h3>

      <p className="text-sm text-gray-600 mt-2 leading-relaxed">
        {text}
      </p>
    </div>
  );
};

/* =========================
   ABOUT CONTENT
========================= */
export const AboutContent = () => {
  const carouselImages = [aboutImg, about2, about3, about4];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % carouselImages.length);
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  const next = () => {
    setActiveIndex((prev) => (prev + 1) % carouselImages.length);
  };

  const prev = () => {
    setActiveIndex(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length
    );
  };

  return (
    <section className="pt-20 pb-6 bg-white">
      <div className="container mx-auto px-4">
        {/* FILA */}
        <div className="grid grid-cols-2 gap-14 md:grid-cols-1 items-center">
          {/* 🔥 CARRUSEL */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              {carouselImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="Cevatur"
                  className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${
                    activeIndex === index
                      ? "opacity-100"
                      : "opacity-0"
                  }`}
                />
              ))}

              <div className="pb-[125%]"></div>

              {/* Flechas */}
              <button
                onClick={prev}
                className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/40 text-white w-10 h-10 rounded-full"
              >
                ❮
              </button>

              <button
                onClick={next}
                className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/40 text-white w-10 h-10 rounded-full"
              >
                ❯
              </button>

              {/* Dots */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                {carouselImages.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    className={`w-3 h-3 rounded-full ${
                      activeIndex === i
                        ? "bg-white"
                        : "bg-white/40"
                    }`}
                  ></button>
                ))}
              </div>
            </div>

            {/* BOX FLOTANTE */}
            <div className="absolute -bottom-8 -right-4 bg-white rounded-2xl shadow-xl p-5 w-64 border">
              <img src={imgs} alt="" className="mb-3" />

              <p className="text-sm text-gray-600 leading-relaxed">
                Más de{" "}
                <span
                  className="font-bold text-lg"
                  style={{ color: COLORS.red }}
                >
                  1,000+
                </span>{" "}
                estudiantes confían en nuestra propuesta educativa.
              </p>
            </div>
          </div>

          {/* TEXTO */}
          <div>
            <span
              className="uppercase text-sm tracking-[3px] font-semibold"
              style={{ color: COLORS.blue }}
            >
              Nuestra Institución
            </span>

            <h2
              className="text-4xl font-bold mt-3 mb-6"
              style={{ color: COLORS.dark }}
            >
              Excelencia académica con propósito profesional
            </h2>

            <p className="text-gray-600 leading-relaxed mb-6">
              En Cevatur promovemos una educación integral basada en
              conocimientos especializados, experiencia práctica y
              formación humana.
            </p>

            <div className="grid grid-cols-2 gap-5 sm:grid-cols-1">
              <InfoMini
                icon={<FaUniversity />}
                title="Prestigio Institucional"
                text="Reconocimiento por calidad y trayectoria."
              />

              <InfoMini
                icon={<FaHandshake />}
                title="Vínculo Empresarial"
                text="Conexión real con el mercado laboral."
              />
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16">
          <div
            className="rounded-3xl p-10 text-center shadow-xl text-white"
            style={{
              background:
                "linear-gradient(135deg,#004AAD,#0060db)",
            }}
          >
            <h3 className="text-3xl font-bold mb-4">
              Solicita información académica
            </h3>

            <p className="max-w-2xl mx-auto text-gray-100 mb-8">
              Nuestro equipo está preparado para orientarte sobre
              carreras, admisión y oportunidades profesionales.
            </p>

            <a
              href="https://wa.me/51967575397"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="px-8 py-4 rounded-xl font-semibold bg-[#25D366] hover:opacity-90 transition inline-flex items-center gap-3 shadow-lg">
                <FaWhatsapp className="text-xl" />
                Contactar por WhatsApp
              </button>
            </a>
          </div>
        </div>

        <div className="mt-8">
          <Administrative />
        </div>
      </div>
    </section>
  );
};

/* =========================
   MINI
========================= */
const InfoMini = ({ icon, title, text }) => {
  return (
    <div className="rounded-2xl p-5 border border-gray-100 bg-gray-50">
      <div
        className="text-xl mb-3"
        style={{ color: COLORS.blue }}
      >
        {icon}
      </div>

      <h4 className="font-bold text-gray-800">{title}</h4>

      <p className="text-sm text-gray-600 mt-2">{text}</p>
    </div>
  );
};